import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface CheckIconProps {
    color?: string;
    className?: string;
}

function CheckIcon({ color = 'currentColor', className = null }: CheckIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            className={classNames([styles.container, className])}
        >
            <path
                d="M5.73787 11.0879L0.513672 5.8637L1.82123 4.55614L5.73787 8.47279L14.1496 0.0670662L15.4572 1.37462L5.73787 11.0879Z"
                fill={color}
            />
        </svg>
    );
}

export default CheckIcon;
